module.exports = __webpack_public_path__ + "img/58.ca215b28.jpg";